export const LIMIT_ROW_IN_TABLE = 10;

export const DEFAULT_SEARCH_PARAMS = '?limit=10&pageNo=0';

export const TABLE_ITEMS_AMOUNT_OPTIONS = ['10', '25', '50', '100'].map((limit) => ({
  label: limit,
  value: limit
}));
